// Rótulos das formas de pagamento (códigos internos -> nome exibido)
export const PAYMENT_LABELS = {
  dinheiro: 'Dinheiro',
  pix: 'PIX',
  cartao: 'Cartão',
  cartao_credito: 'Cartão de Crédito',
  cartao_debito: 'Cartão de Débito',
  credito: 'Cartão de Crédito',
  debito: 'Cartão de Débito',
  a_receber: 'A Receber (Fiado)',
  fiado: 'A Receber (Fiado)',
  crediario: 'Crediário',
  boleto: 'Boleto',
  transferencia: 'Transferência',
  cheque: 'Cheque',
  outro: 'Outro',
};

export const paymentCodeLabel = (code) => {
  if (!code) return 'Outro';
  const k = String(code).toLowerCase();
  return PAYMENT_LABELS[k] || (k.charAt(0).toUpperCase() + k.slice(1));
};

// Deriva a(s) forma(s) de pagamento de uma venda a partir do array payment_methods
// (campo atual). Mantém compatibilidade com vendas antigas (payment_method/metodo_pagamento).
export const getSalePaymentLabel = (sale) => {
  const pms = Array.isArray(sale?.payment_methods)
    ? sale.payment_methods.filter((pm) => pm && pm.method)
    : [];
  if (pms.length > 0) {
    return [...new Set(pms.map((pm) => paymentCodeLabel(pm.method)))].join(' + ');
  }
  const legacy = sale?.payment_method || sale?.metodo_pagamento || sale?.forma_pagamento;
  return legacy ? paymentCodeLabel(legacy) : '—';
};
